import brandDomains from "./hostConfig";

//Adding keys here as this is client side brand specific rendering
const KEYS = {
    61: {
        bucket: "cms-integration-production-a57f4ae0-4c21-11f0-8eb8-e58dbeebc24f",
        key: "pb1MHE3qpISbIWd8SrqrSoa8dfDPbk6JXnSgMv6xwpTOR1BcA2"
    },

}

const getBrandId = (host: string = '') => {
    try {
        let brandId = brandDomains.find(bd => bd.domain === host)?.id;
        return brandId || 31;
    } catch (e) {
        console.log('Get brand id failed.', e);
        return 31;
    }
};

const getKey = () => {
    let obj = {
        bucket: "",
        key: ""
    }

    if (typeof window.location === 'object') {
        const _path = window.location.host;

        if (_path) {
            const getBrand = getBrandId(_path);
            const keys = KEYS[getBrand];
            return keys || obj;
        }
    }

    return obj;
}

const getURL = (query: string, props: string) => {
    const { bucket, key } = getKey();
  
    if (!bucket || !key) {
        return;
    }
    // const bucket = 'cms-integration-production-a57f4ae0-4c21-11f0-8eb8-e58dbeebc24f';
    // const key = 'pb1MHE3qpISbIWd8SrqrSoa8dfDPbk6JXnSgMv6xwpTOR1BcA2';
    const url = `https://api.cosmicjs.com/v3/buckets/${bucket}/objects?pretty=true&query=${query}&skip=0&read_key=${key}&depth=1&props=${props},`;

    return url;
}

const getData = async (url: string) => {
    try {
        const resp = await fetch(url, { cache: 'force-cache' })
        if (!resp.ok) {
            throw new Error(`Response status: ${resp.status}`);
        }

        const respJson = await resp.json();
        return respJson;

    } catch (error) {
        console.error(error.Message);

    }

    return {}

}


//API DATA

export const homePageSEOData = async () => {
    const url = getURL('%7B%22type%22:%22homepage-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
    //return seoAPI.get(_url)
}

export const liveCasinosSEOData = async () => {
    const url = getURL('%7B%22type%22:%22live-casino-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const instantGamesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22instant-games-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const slotsGamesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22slots-desktops%22%7D&limit=613', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const sportsGamesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22sports-desktops%22%7D&limit=300', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const otherPagesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22other-pages-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const bonusPagesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22bonus-pages-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const authPagesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22auth-pages-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const tncPagesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22tnc-page-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}

export const otherGamePagesSEOData = async () => {
    const url = getURL('%7B%22type%22:%22other-game-page-desktops%22%7D&limit=210', 'slug,title,metadata,type');
    const response = await getData(url);
    return response;
}